import { render, staticRenderFns } from "./PopChatWizard.vue?vue&type=template&id=7ed50838&lang=pug"
import script from "./PopChatWizard.vue?vue&type=script&lang=js"
export * from "./PopChatWizard.vue?vue&type=script&lang=js"
import style0 from "./PopChatWizard.vue?vue&type=style&index=0&id=7ed50838&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports